import { Download, FolderInput, Share2, Trash2 } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui";

interface VaultSelectionBarProps {
  count: number;
  onClear: () => void;
}

export function VaultSelectionBar({ count, onClear }: VaultSelectionBarProps) {
  return (
    <div className="flex shrink-0 items-center gap-2 border-b border-border bg-muted/30 px-5 py-2">
      <span className="text-xs text-muted-foreground">
        <span className="font-semibold text-foreground">{count}</span> selected
      </span>
      <div className="ml-2 flex gap-1.5">
        <Button size="sm" variant="default" className="h-7 gap-1 text-xs" onClick={() => toast.info("Share coming soon")}>
          <Share2 className="size-3" aria-hidden="true" />
          Share
        </Button>
        <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={() => toast.info("Move coming soon")}>
          <FolderInput className="size-3" aria-hidden="true" />
          Move
        </Button>
        <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={() => toast.info("Download coming soon")}>
          <Download className="size-3" aria-hidden="true" />
          Download
        </Button>
        <Button size="sm" variant="outline" className="h-7 gap-1 text-xs" onClick={() => toast.info("Delete coming soon")}>
          <Trash2 className="size-3" aria-hidden="true" />
          Delete
        </Button>
      </div>
      <Button size="sm" variant="ghost" className="ml-auto h-7 text-xs" onClick={onClear}>
        Clear
      </Button>
    </div>
  );
}
